// Polyfill for Promise.withResolvers (ES2024 feature)
// NOTE: pdfjs-dist requires this for older browsers
// This polyfill provides the ES2024 Promise.withResolvers method for Safari <17.4 and other older browsers

declare global {
  interface PromiseConstructor {
    withResolvers<T>(): {
      promise: Promise<T>;
      resolve: (value: T | PromiseLike<T>) => void;
      reject: (reason?: any) => void;
    };
  }
}

if (typeof Promise.withResolvers !== "function") {
  Promise.withResolvers = function <T>() {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: any) => void;

    const promise = new Promise<T>((resolveFunc, rejectFunc) => {
      resolve = resolveFunc;
      reject = rejectFunc;
    });

    return { promise, resolve, reject };
  };
}

export {};
